<template>
  <div id="app" class="min-h-screen bg-black text-white">
    <!-- Navbar -->
    <NavBar />

    <!-- Main Content -->
    <main class="max-w-7xl mx-auto px-4 py-4">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" :key="$route.fullPath" />
        </transition>
      </router-view>
    </main>

    <!-- Footer -->
    <footer class="bg-gray-800 text-white text-center py-6 mt-12">
      <p>&copy; 2026 Sistema de Torneo de Capoeira. Todos los derechos reservados.</p>
    </footer>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import NavBar from './components/NavBar.vue'

const router = useRouter()
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
